// extracted by mini-css-extract-plugin
export default {"wrapper":"TableHeaderWrapper_wrapper__n3bed"};